export default __webpack_public_path__ + "static/media/goshen83.d0c0b5cf.jpg";